import { render, staticRenderFns } from "./SmartnewsInputs.vue?vue&type=template&id=55504fac&scoped=true"
import script from "./SmartnewsInputs.vue?vue&type=script&lang=js"
export * from "./SmartnewsInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55504fac",
  null
  
)

export default component.exports